import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { CSGOModel } from "../../models/CSGOModel";
import CSGOService from "../../services/CSGOService";
import CSGOSlice from "../slices/CSGOSlice";
import { RootState } from "../store";

export const CSGOActions = CSGOSlice.actions;
export const fetchCSGOs = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(CSGOActions.setIsCsgoFetching(true));
    const response: CSGOModel[] = await CSGOService.getAllCSGOs();
    dispatch(CSGOActions.setCSGOs(response));
    dispatch(CSGOActions.setIsCsgoFetching(false));
  };
};
export const fetchParticularCSGO = (
  CSGO_id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const response: CSGOModel = await CSGOService.getParticularCSGO(CSGO_id);
    dispatch(CSGOActions.setParticularCSGO(response));
  };
};
